import React, { useEffect, useState } from 'react';
import CommonCardComponent from '@components/common/CommonCardComponent';
import CommonFormFields from '@pages/Forms/CommonFormFields';
import './overview.css'
import Delete from '../../../assets/svg_main/delete.svg';
import EditIcon from '../../../assets/svg_main/edit_outline.svg';
import { Modal } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import endpoints from '@config/endpoints';
import LinkUnlinkHistoryButton from './Button';
import Button from '@components/common/Button';
import { getData, postDataJSON } from '../../../services/CommonApiService';
import { useDispatch, useSelector } from 'react-redux';
import { updateForm } from '@store/actions/userManagementAction';
import UserFacilityModal from '@components/common/FacilityDetailsModal';
import CheckboxComponent from '../../../components/common/CheckBox';
import Collapse from 'react-bootstrap/Collapse';
import DownArrow from '@assets/svg/down-arrow.svg';
import UpArrow from '@assets/svg/up-arrow.svg';
import profilePic from '@assets/png/default_profile.png';
import { RootState } from '@store/reducers';
import TooltipComponent from '@components/common/TooltipComponent';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import { PagePermission} from '../../../services/usePermission';
import { errorLogger } from '@utils/applicationLogUtils';
import { decodeWithKeyAndShift } from '@utils/base64Utils';

const today = new Date();

interface objectTypes {
  isError: boolean,
  message: string,
  isDisable: boolean,
  value: any,
  id?: any,
  verifiedDetails?: any
  code?: number
}
interface formStateType {
  [key: string]: objectTypes
}

interface formDataType {
  [key: string]: any;
}

const HealthProviderAction = (props: any) => {
  const userData = JSON.parse(decodeWithKeyAndShift(localStorage.getItem('userDetails')));
  const canEditUser    = PagePermission("UserMgmt_HPM", "HPM_EdPg");
  const canDeleteUser  = PagePermission("UserMgmt_HPM", "HPM_DelPg");
  const canHistoryUser = PagePermission("UserMgmt_HPM", "HPM_HstPg");
  const canLinkUser    = PagePermission("UserMgmt_HPM", "HPM_LinkPg");
  const canUnLinkUser  = PagePermission("UserMgmt_HPM", "HPM_UnLinkPg");

  const [deleteForm, setDeleteForm] = useState<formStateType>({
    remarks: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    }
  })
  const [deleteData, setDeleteData] = useState<formDataType>({
    remarks: {
      '#type': 'textArea',
      '#title': 'Remarks',
      '#webform_key': 'remarks',
      '#required': true,
      '#isDisabled': false,
      '#options': {
      }
    }
  })
  const [modalData, setModalData] = useState<formDataType>({});
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();
  const handleClose = () => {
    setShowModal(false)
    setIsDeleteButtonCLicked(false);
  }
  const [modalForm, setModalForm] = useState<formStateType>({
    effective_from_date: {
      isError: false,
      message: '',
      isDisable: false,
      value: ''
    },
    reasonForUnlinking: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    reasonForInactive: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    remarks: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    }
  });
  const [linkedFacility, setLinkedFacility] = useState<any>([]);
  const { id } = useParams();
  const [userDetails, setUserDetails] = useState<any>([]);
  const [isUnlinkClicked,setIsUnlinkCLicked]=useState<boolean>(false);
  const [rolesData, setRolesData] = useState<any>([]);
  const [effectiveToDate, setEffectiveToDate] = useState<any>('');
  const [effectiveFromDate, setEffectiveFromDate] = useState<any>('');
  const [isDeleteButtonClicked, setIsDeleteButtonCLicked] = useState(false);
  const [currentDate, setCurrentDate] = useState('');
  const [formattedCurrentDate, setFormattedCurrentDate] = useState<any>('')
  const [isFacilityOrFieldUser, setIsFacilityOrFieldUser] = useState<string>('');
  const linkedFacilitiesCount = useSelector((state: RootState) => state.user.linkedFacilityCount);
  const isLinkUnLinkButtonCLicked = useSelector((state: RootState) => state.user.isLinkUnLinkButtonCLicked);
  const handleFormChange = (value: any, key: string, id?: any, option?: any, code?: any, field?: formDataType | undefined) => {
    if (key === "remarks" && value.length > 30) {
      return;
    }
    setModalForm((prevState: any) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        value: value,
        isError: false,
        message: '',
        id: id,
        code: code
      },
    }));
  }

  useEffect(() => {
    if (showModal) {
      fetchLinkedFacilitiesByUserId(props.user.uf_id)
    }

  }, [showModal])

  useEffect(() => {
    if (modalForm.reasonForUnlinking.value === "Inactive") {
      
      const fetchInactiveReasonData = async () => {
       const inActiveReasons = await getData<any[]>(`${endpoints.getInActiveReason}`);
        
        setModalData((prevState) => ({
          effctive_from_date: {
            '#type': 'date',
            '#title': 'Effective From Date',
            '#webform_key': 'effective_from_date',
            '#required': true,
            '#isDisabled': false,
            '#dateMinimum': 'true',
            '#maxDate': dayjs(new Date()).format('YYYY-MM-DD'),
            '#minDate': props.user.effective_from_dt,
            '#options': {
            },
          },
          reasonForUnlinking: {
            '#type': 'select',
            '#title': 'Reason For Unlinking',
            '#webform_key': 'reasonForUnlinking',
            '#required': true,
            '#options': [{
              value: "Inactive",
              label: "Inactive",
              id: "Inactive"
            }, {
              value: "Shift/ Transfer",
              label: "Shift/ Transfer",
              id: "Shift/ Transfer"
            },
            {
              value: "Link New Facility",
              label: "Link New Facility",
              id: "Link New Facility"
            }
            ]
          },
          reasonForInactive: {
            '#type': 'select',
            '#title': 'Reason For Inactive',
            '#webform_key': 'reasonForInactive',
            '#required': true,
            '#options': [{
              value: inActiveReasons.data[0].reason_name,
              label: inActiveReasons.data[0].reason_name,
              id: inActiveReasons.data[0].reason_id
            }, {
              value: inActiveReasons.data[1].reason_name,
              label: inActiveReasons.data[1].reason_name,
              id: inActiveReasons.data[1].reason_id
            },
            ]
          },
          remarks: {
            '#type': 'textArea',
            '#title': 'Remarks',
            '#webform_key': 'remarks',
            '#required': false,
            '#isDisabled': false,
            '#options': {
            },
          }
        }));
      }
      fetchInactiveReasonData();
      
    }
    else {
      setModalData((prevState) => ({
        effctive_from_date: {
          '#type': 'date',
          '#title': 'Effective From Date',
          '#webform_key': 'effective_from_date',
          '#required': true,
          '#isDisabled': false,
          '#dateMinimum': 'true',
          '#maxDate': dayjs(new Date()).format('YYYY-MM-DD'),
          '#minDate': props.user.effective_from_dt,
          '#options': {
          },
        },
        reasonForUnlinking: {
          '#type': 'select',
          '#title': 'Reason For Unlinking',
          '#webform_key': 'reasonForUnlinking',
          '#required': true,
          '#options': [{
            value: "Inactive",
            label: "Inactive",
            id: "Inactive"
          }, {
            value: "Shift/ Transfer",
            label: "Shift/ Transfer",
            id: "Shift/ Transfer"
          },
          {
            value: "Link New Facility",
            label: "Link New Facility",
            id: "Link New Facility"
          }
          ]
        },
        remarks: {
          '#type': 'textArea',
          '#title': 'Remarks',
          '#webform_key': 'remarks',
          '#required': false,
          '#isDisabled': false,
          '#options': {
          },
        }
      }));
    }
  }, [modalForm.reasonForUnlinking.value])
  useEffect((
  ) => {
    // if(props.user.is_linked){
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const year = today.getFullYear();
    setCurrentDate(`${day}-${month}-${year}`);
    const toDate = props.user.effective_to_dt !== '-----' ? new Date(props.user.effective_to_dt.split("-").reverse().join("-")) : '';
    const fromDate = props.user.effective_from_dt !== '-----' ? new Date(props.user.effective_from_dt.split("-").reverse().join("-")) : '';
    const presentDate = new Date(`${day}-${month}-${year}`.split("-").reverse().join("-"));
    
    //
    setEffectiveToDate(toDate);
    setEffectiveFromDate(fromDate);
    setFormattedCurrentDate(presentDate)

    // }
  }, [props.user])

  
  const fetchLinkedFacilitiesByUserId = async (userId: any) => {
    const healthProviderDataFetch = await getData<any[]>(`${endpoints.getLinkedFacilitiesByUser(userId)}`);
    setLinkedFacility(healthProviderDataFetch.data[0][0]);
  }

  const handleLink = async () => {
    let isModalFormError = false;
    {
      const modalFormError = {
        ...modalForm
      };
      Object.keys(modalFormError).map((item) => {
        if (item === 'effective_from_date') {
          if (modalFormError.effective_from_date.value === null ||
            modalFormError.effective_from_date.value === ''
          ) {
            isModalFormError = true;
            modalFormError.effective_from_date.isError = true;
            modalFormError.effective_from_date.message = 'Effective From Date is mandatory';
          }
          else {
            modalFormError.effective_from_date.isError = false;
          }
        }
      })
      setModalForm(modalFormError);
      isError[0] = isModalFormError;
    }
    if (!isModalFormError) {
      // const dateStr = modalForm.effective_from_date.value;
      // const dateObj = new Date(dateStr);
      // dateObj.setDate(dateObj.getDate() + 1);
      // const newDateStr = dateObj.toISOString();

      const healthProviderIds = Array(linkedFacility?.health_provider_details)?.length > 0 ? linkedFacility?.health_provider_details?.map((item:any) => item.health_provider_id) : [];
      const mobilizerIds = Array(linkedFacility?.mobiliser_provider_details)?.length > 0 ? linkedFacility?.mobiliser_provider_details?.map((item:any) => item.mobiliser_id) : [];
      const wardIds = Array(linkedFacility?.v_ward_details)?.length > 0 ? linkedFacility?.v_ward_details?.map((wd:any)=>wd?.ward_id) : [];
      const villageIds = Array(linkedFacility?.v_village_details)?.length > 0 ? linkedFacility?.v_village_details?.map((vd:any)=>vd?.village_id) : [];
      const gramPanchayatIds = Array(linkedFacility?.v_gram_panchayat_details)?.length > 0 ? linkedFacility?.v_gram_panchayat_details?.map((gd:any)=>gd?.gram_panchayat_id) : [];


      const data = {
        userId: id,
        facilityId: linkedFacility.facility_id,
        healthProviderId: userDetails?.usertype_name==='Field Level User' ? healthProviderIds ? healthProviderIds : [] : [],
        mobilzerId: userDetails?.usertype_name==='Facility Level User' ? mobilizerIds ? mobilizerIds : [] : [],
        wardId: wardIds ? wardIds: [],
        effectiveFromDate: new Date(dayjs(modalForm.effective_from_date.value).format('YYYY-MM-DD')).toISOString().split('T')[0],
        villageId: villageIds ? villageIds : [],
        gramPranchayatIds: gramPanchayatIds ? gramPanchayatIds : [],
        remarks: modalForm.remarks.value,
        parentUserId: localStorage.getItem('userId'),
        parentUserTypeId: null,
        parentRollId: null
      }
      try {
        const response = await postDataJSON(`${endpoints.linkFacilityForUser}`, data);
        dispatch(updateForm("isLinkUnLinkButtonCLicked", true))
        handleClose();
        toast.success("Facility have been linked successfully", {
          position: "top-center"
        });
      }
      catch(error:any){
        errorLogger(error?.response?.data||error?.response||error)
      }
    }
  }
  const handleUnlink = async () => {
    let isModalFormError = false;
    {
      const modalFormError = {
        ...modalForm
      };
      Object.keys(modalFormError).map((item) => {
        if (item === 'effective_from_date') {
          if (modalFormError.effective_from_date.value === null ||
            modalFormError.effective_from_date.value === ''
          ) {
            isModalFormError = true;
            modalFormError.effective_from_date.isError = true;
            modalFormError.effective_from_date.message = 'Effective To Date is mandatory';
          }
          else {
            modalFormError.effective_from_date.isError = false;
          }
        }

        if (linkedFacilitiesCount === 1 && item === 'reasonForUnlinking') {
          if (modalFormError.reasonForUnlinking.value === null ||
            modalFormError.reasonForUnlinking.value === ''
          ) {
            isModalFormError = true;
            modalFormError.reasonForUnlinking.isError = true;
            modalFormError.reasonForUnlinking.message = 'Reason for Unlinking is mandatory';
          }
          else {
            modalFormError.reasonForUnlinking.isError = false;
          }
        }

        if (linkedFacilitiesCount === 1 && item === 'reasonForUnlinking' && modalForm.reasonForUnlinking.value === "Inactive") {
          if (modalFormError.reasonForInactive.value === null ||
            modalFormError.reasonForInactive.value === ''
          ) {
            isModalFormError = true;
            modalFormError.reasonForInactive.isError = true;
            modalFormError.reasonForInactive.message = 'Reason for Inactive is mandatory';
          }
          else {
            modalFormError.reasonForInactive.isError = false;
          }
        }
      })
      setModalForm(modalFormError);
      isError[0] = isModalFormError;
    }
    if (!isModalFormError) {
      // const dateStr = modalForm.effective_from_date.value;
      // const dateObj = new Date(dateStr);
      // dateObj.setDate(dateObj.getDate() + 1);
      // const newDateStr = dateObj.toISOString();
      const data = {
        ufTaggedId: props.user.uf_id,
        effectiveFromDate: dayjs(modalForm.effective_from_date.value).format("YYYY-MM-DD"),
        remarks: modalForm.remarks.value,
        parentUserId: localStorage.getItem('userId'),
        parentUserTypeId: null,
        parentDesignationId: null,
        parentRollId: null,
        statusId: modalForm.reasonForInactive.id
      }
      if (linkedFacilitiesCount === 1 && modalForm.reasonForUnlinking.value !== 'Inactive') {
        dispatch(updateForm("unlinkPayload", data));
        if (modalForm.reasonForUnlinking.value === 'Shift/ Transfer') {
          dispatch(updateForm("navigateShiftTransfer", true));
        }
        else {
          dispatch(updateForm("navigateLinkPayload", true));
          handleClose()
        }
      }
      else {
        try {
          const response = await postDataJSON(`${endpoints.unLinkFacilityForUser}`, data);
          dispatch(updateForm("isLinkUnLinkButtonCLicked", true))
          handleClose()
          if(linkedFacilitiesCount === 1 && modalForm.reasonForUnlinking.value === 'Inactive'){
            dispatch(updateForm("isUserActive", false));
              setIsUnlinkCLicked(true); 
          }
          toast.success("Facility have been successfully unlinked", {
            position: "top-center"
          });
        }
        catch(error:any){
          errorLogger(error?.response?.data||error?.response||error)
        }
      }

    }
  }
  const isError: boolean[] = [];
  const handleDelete = async () => {
    let isDeleteFormError = false;

    {
      const deleteFormError = {
        ...deleteForm
      };
      Object.keys(deleteFormError).map((item) => {
        if (item === 'remarks') {
          if (deleteFormError.remarks.value === null ||
            deleteFormError.remarks.value === ''
          ) {
            isDeleteFormError = true;
            deleteFormError.remarks.isError = true;
            deleteFormError.remarks.message = 'Remarks is mandatory';
          }
          else {
            deleteFormError.remarks.isError = false;
          }
        }
      })
      setDeleteForm(deleteFormError);
      isError[0] = isDeleteFormError;
    }
    const data = {
      userfacilityId: props.user.uf_id,
      remarks: deleteForm.remarks.value,
      parentUserId: localStorage.getItem('userId'),
      parentUserTypeId: null,
      parentRollId: null
    }

    try {
      if (!isDeleteFormError) {
        const response = await postDataJSON(`${endpoints.deleteLinkFacilityForUser}`, data);
        dispatch(updateForm("isFacilityDeleted", true))
        setIsDeleteButtonCLicked(false)
        handleClose()
      }
    }
    catch(error:any){
      errorLogger(error?.response?.data||error?.response||error)
    }
  }
  
  const [facilityHistory, setFacilityHistory] = useState<any>([])
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const userDetail = await getData<any[]>(`${endpoints.getUserById}/${id}`);
        setUserDetails(userDetail.data[0]);
        const roles = await getData<any[]>(`${endpoints.getRoleByUserId(id)}`)
        setRolesData(roles.data);
        const userDetails = userDetail.data[0];
        if(userDetails?.usertype_name==='Facility Level User'){
          setIsFacilityOrFieldUser('Facility Level User');
        }
        else if(userDetails?.usertype_name==='Field Level User'){
          setIsFacilityOrFieldUser('Field Level User');
        }
        else{
          setIsFacilityOrFieldUser('');
        }
      }
      catch(error:any){
        errorLogger(error?.response?.data||error?.response||error)
      }
    }
    fetchUserData()
  }, [isLinkUnLinkButtonCLicked]);
  
  
  const facHistName = facilityHistory[0]?.facility_name;
  
  
  const [showFacHistory, setShowFacHistory] = useState<boolean>(false);
  const [show, setShow] = useState<boolean>(false);
  const handleClickHistory = () => {
    const fetchFacilityHistory = async () => {
      let linkedFacilityHistory: any[] = [];
      try {
        const data = {
          p_user_id: id,
          p_facility_id: props.user.facility_id
        }
        const linkFacHis = await getData<any>(`${endpoints.getLinkedFacilityHistoryPerRecord}/${id}/${props.user.facility_id}`);
        
        linkedFacilityHistory = linkFacHis.data;

        linkedFacilityHistory.forEach((item) => {
          item.effective_from_dt = item.effective_from_dt && dayjs(item.effective_from_dt).format('DD-MM-YYYY');
          item.effective_to_dt = item.effective_to_dt && dayjs(item.effective_to_dt).format('DD-MM-YYYY');
        }
        );
        
        setFacilityHistory(linkedFacilityHistory);
      }
      catch(error:any){
        errorLogger(error?.response?.data||error?.response||error)
      }
    }
    fetchFacilityHistory();
    setShowFacHistory(true);
    setShow(true);

  }
  const closeUserFacilityModal = () => {
    setShow(false);
    setShowFacHistory(false);
    setHistOpen(false);
  }
  const isInactiveForEdit = userDetails?.user_status === 'Inactive' || ((props.user.effective_to_dt !== '-----' && props.user.effective_from_dt !== '-----') || effectiveFromDate > formattedCurrentDate);
  const isInactiveDelete = currentDate === props.user.effective_from_dt;
  const marginClass = props.user?.is_parent ? 'margin-parent' : 'margin-none'
  const [histOpen, setHistOpen] = useState<boolean>(false)
  const keys = facilityHistory ? Object.keys(facilityHistory) : [];
  // const histKey = keys.length > 0 ? keys[0].split("/") : [];
  // const [openItems, setOpenItems] = useState<any>({});
  // const handleFacHistoryList = (item : any) => {
  //   setOpenItems((prevOpenItems: { [x: string]: any; }) => ({
  //     ...prevOpenItems,
  //     [item]: !prevOpenItems[item],
  //   }));
  // };

  const handleCheckLinkedFacility = () => {
    return facilityHistory?.filter((ele: any) => ele.is_linked === true ).length > 0 ? 'linked' : 'unLinked';
  };

  const roleNames = (<div className='facility-history-role-name-css'>
    {rolesData?.map((role: any, index: any) => (
      <div key={index}>{role.role_name}{","}</div>
    ))}
  </div>)
  const contents = (
    <div className='facility_details_history'>
      <div className='view-profile'>
        {
          <img
            className="profile-picture"
            src={profilePic}
            alt='Profile Image'
          />
        }
        <div className="name-type">
          <div className="name">{userDetails?.first_name}</div>
          <div className="type">{userDetails?.usertype_name}{" > "}{roleNames}</div>
        </div>
      </div>
      <div className='facility-history-second-content'>
        <div className='fu-details-history-checkbox'>
          <CheckboxComponent
            className="fu-details-history-active"
            checkBoxName="Linked"
            disabled={true}
            onCheckboxChange={(value) => { }}
            placeCheckboxBefore={false}
          />
          <CheckboxComponent
            className="fu-details-history-inactive"
            checkBoxName="Unlinked"
            disabled={true}
            onCheckboxChange={(value) => { }}
            placeCheckboxBefore={false}
          />
        </div>
        <div className='health-facilities-history-container'>
          <div className='history-facilities-list'>
            <div>
              <div className={`facility-item-container ${handleCheckLinkedFacility()}`} onClick={() => setHistOpen(!histOpen)}>
                <div className='facility-item'>
                  <div className='hf-name-value-css'><p className='hf-name'>Health Facility Name</p>
                    <p className='hf-name-type-semicolon'>:</p>
                    <p className='hf-name-value'>{facilityHistory[0]?.facility_name}</p>
                  </div>
                  <div className='hf-name-type-value-css'>
                    <p className='hf-name-type'>Health Facility Type</p>
                    <p className='hf-name-type-semicolon'>:</p>
                    <p className='hf-type-value'>{facilityHistory[0]?.facility_type_name}</p>
                  </div>
                  {
                    histOpen === true ?
                      <div className='down-arrow-svg-css'><UpArrow className='down-arrow-svg' /></div>
                      :
                      <div className='down-arrow-svg-css'><DownArrow className='down-arrow-svg' /></div>
                  }
                </div>
                <div className='facility-item2'>
                  <div className='hf-id-type-value-css'><p className='hf-id-facility'>HFR ID</p><p className='hf-id-type-semicolon'>:</p><p className='hf-id-value'>{facilityHistory[0]?.hfr_id}</p></div>
                </div>
                {facilityHistory &&
                  facilityHistory.map((data: any) => (
                    <Collapse in={histOpen} key={data}>
                      <div className={`card-facility-history`}>
                        {
                          data.is_linked === true ?
                            <div className='card-facility-history-active'>
                              <CommonCardComponent cardBodyContent={
                                <div className='card-fac-actv-css'>
                                  {/* <div className='card-ef-frm-dt'> */}
                                  <p className='card-ef-frm-dt-name'>Effective From Date</p>
                                  <p className='card-ef-frm-dt-name-value'>{data.effective_from_dt === null ? '-  -  -  -  - ' : data.effective_from_dt}</p>
                                  {/* </div>
                                        <div className='card-ef-to-dt'> */}
                                  <p className='card-ef-to-dt-name'>Effective To Date</p>
                                  <p className='card-ef-to-dt-name-value'>{data.effective_to_dt === null ? '-  -  -  -  - ' : data.effective_to_dt}</p>
                                  {/* </div>
                                        <div className='card-ef-mob-tag'> */}
                                  <p className='card-ef-mob-tag-name'>{isFacilityOrFieldUser === "Facility Level User" ? 'Asha/Mobiliser Tagged' : 'ANM/ Health Provider Tagged' }</p>
                                  <p className='card-ef-mob-tag-name-value'>{data.healthprovider_details === null ? (data.mobiliser_details !== null ? data.mobiliser_details.map((mb:any)=>mb.mobiliser_name).join(', ') : '-  -  -  -  - '):data.healthprovider_details.map((hp:any)=>hp.healthprovider_name).join(', ')}</p>
                                  {/* </div>
                                        <div className='card-ef-rem'> */}
                                  <p className='card-ef-rem-name'>Remarks</p>
                                  <p className='card-ef-rem-name-value'>{data.remarks === null ? '-  -  -  -  - ' : data.remarks}</p>
                                  {/* </div> */}
                                </div>
                              } />
                            </div> :
                            <div className='card-facility-history-inactive'>
                              <CommonCardComponent cardBodyContent={
                                <div className='card-fac-inactv-css'>
                                  {/* <div className='card-ef-frm-dt'> */}
                                  <p className='card-ef-frm-dt-name'>Effective From Date</p>
                                  <p className='card-ef-frm-dt-name-value'>{data.effective_from_dt === null ? '-  -  -  -  - ' : data.effective_from_dt}</p>
                                  {/* </div>
                                              <div className='card-ef-to-dt'> */}
                                  <p className='card-ef-to-dt-name'>Effective To Date</p>
                                  <p className='card-ef-to-dt-name-value'>{data.effective_to_dt === null ? '-  -  -  -  - ' : data.effective_to_dt}</p>
                                  {/* </div>
                                              <div className='card-ef-mob-tag'> */}
                                  {/* </div>
                                              <div className='card-ef-rem'> */}
                                  <p className='card-ef-rem-name'>Remarks</p>
                                  <p className='card-ef-rem-name-value'>{data.remarks === null ? '-  -  -  -  - ' : data.remarks}</p>
                                  {/* </div> */}
                                </div>
                              } />
                            </div>
                        }
                      </div>
                    </Collapse>
                  ))
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
  return (
    <>
      <div className="button_wrapper">
        <div className={isInactiveForEdit ? 'editInactive' : 'editActive'}>
            {canEditUser && (
              <TooltipComponent text="Edit" >
                <EditIcon
                  onClick={() => {
                    props.user.Action.setShowEditLinkedFacility(true);
                    //dispatch(updateForm("isEditButtonCLicked", true))
                    dispatch(updateForm("linkedFacilityId", props.user.uf_id))
                  }
                  }
                />
              </TooltipComponent>
            )}
        </div>
        {
          !props.user?.is_parent && <>
            <div  className={isInactiveDelete? 'visible' : 'hidden'}
            >
            {canDeleteUser && (
              <TooltipComponent text="Delete" >
                <Delete
                  onClick={() => {

                    setDeleteForm((prevState: any) => ({
                      ...prevState,
                      ['remarks']: {
                        ...prevState['remarks'],
                        value: '',
                        isError: false,
                        message: '',
                        id: '',
                        code: ''
                      },
                    }));
                    setIsDeleteButtonCLicked(true)
                    setShowModal(true);
                  }
                  }
                />
              </TooltipComponent>
            )}
            </div>
          </>
        }

       {<div className={marginClass}
       > 
      {(canLinkUser || canUnLinkUser) && (
       <LinkUnlinkHistoryButton
          onClick={() => {
            setShowModal(true);
            if (props.user.is_linked) {
              if (linkedFacilitiesCount === 1) {
                setModalForm((prevState: any) => ({
                  ...prevState,
                  ['effective_from_date']: {
                    ...prevState['effective_from_date'],
                    value: '',
                    isError: false,
                    message: '',
                    id: '',
                    code: ''
                  },
                  reasonForUnlinking: {
                    isError: false,
                    message: '',
                    isDisable: false,
                    value: '',
                  },
                  reasonForInactive: {
                    isError: false,
                    message: '',
                    isDisable: false,
                    value: '',
                  },
                  ['remarks']: {
                    ...prevState['remarks'],
                    value: '',
                    isError: false,
                    message: '',
                    id: '',
                    code: ''
                  },
                }));
                setModalData((prevState) => ({
                  effctive_from_date: {
                    '#type': 'date',
                    '#title': 'Effective From Date',
                    '#webform_key': 'effective_from_date',
                    '#required': true,
                    '#isDisabled': false,
                    '#dateMinimum': 'true',
                    '#maxDate': dayjs(new Date()).format('YYYY-MM-DD'),
                    '#minDate': new Date(new Date(props.user.effective_from_dt.split("-").reverse().join("-")).
                      setDate(new Date(props.user.effective_from_dt.split("-").reverse().join("-")).getDate() + 1)).toISOString().split('T')[0],
                    '#options': {
                    },
                  },
                  reasonForUnlinking: {
                    '#type': 'select',
                    '#title': 'Reason For Unlinking',
                    '#webform_key': 'reasonForUnlinking',
                    '#required': true,
                    '#options': [{
                      value: "Inactive",
                      label: "Inactive",
                      id: "Inactive"
                    }, {
                      value: "Shift/ Transfer",
                      label: "Shift/ Transfer",
                      id: "Shift/ Transfer"
                    },
                    {
                      value: "Link New Facility",
                      label: "Link New Facility",
                      id: "Link New Facility"
                    }
                    ]
                  },
                  remarks: {
                    '#type': 'textArea',
                    '#title': 'Remarks',
                    '#webform_key': 'remarks',
                    '#required': false,
                    '#isDisabled': false,
                    '#options': {
                    },
                  }
                }));
              }
              else {
                setModalData((prevState) => ({
                  effctive_from_date: {
                    '#type': 'date',
                    '#title': 'Effective From Date',
                    '#webform_key': 'effective_from_date',
                    '#required': true,
                    '#isDisabled': false,
                    '#dateMinimum': 'true',
                    '#maxDate': dayjs(new Date()).format('YYYY-MM-DD'),
                    '#minDate': new Date(new Date(props.user.effective_from_dt.split("-").reverse().join("-")).
                      setDate(new Date(props.user.effective_from_dt.split("-").reverse().join("-")).getDate() + 1)).toISOString().split('T')[0],
                    '#options': {
                    },
                  },
                  remarks: {
                    '#type': 'textArea',
                    '#title': 'Remarks',
                    '#webform_key': 'remarks',
                    '#required': false,
                    '#isDisabled': false,
                    '#options': {
                    },
                  }
                }));
                setModalForm((prevState: any) => ({
                  ...prevState,
                  ['effective_from_date']: {
                    ...prevState['effective_from_date'],
                    value: '',
                    isError: false,
                    message: '',
                    id: '',
                    code: ''
                  },
                  ['remarks']: {
                    ...prevState['remarks'],
                    value: '',
                    isError: false,
                    message: '',
                    id: '',
                    code: ''
                  },
                }));
              }
            }
            else {
              setModalData((prevState) => ({
                effctive_from_date: {
                  '#type': 'date',
                  '#title': 'Effective From Date',
                  '#webform_key': 'effective_from_date',
                  '#required': true,
                  '#isDisabled': false,
                  '#dateMinimum': 'true',
                  '#maxDate': dayjs(new Date()).format('YYYY-MM-DD'),
                  '#minDate': dayjs(new Date(new Date(props.user.effective_to_dt.split("-").reverse().join("-")).
                    setDate(new Date(props.user.effective_to_dt.split("-").reverse().join("-")).getDate() + 1))).toISOString().split('T')[0],
                  '#options': {
                  },
                },
                remarks: {
                  '#type': 'textArea',
                  '#title': 'Remarks',
                  '#webform_key': 'remarks',
                  '#required': false,
                  '#isDisabled': false,
                  '#options': {
                  },
                }
              }));
              setModalForm((prevState: any) => ({
                ...prevState,
                ['effective_from_date']: {
                  ...prevState['effective_from_date'],
                  value: '',
                  isError: false,
                  message: '',
                  id: '',
                  code: ''
                },
                ['remarks']: {
                  ...prevState['remarks'],
                  value: '',
                  isError: false,
                  message: '',
                  id: '',
                  code: ''
                },
              }));
            }
          }}
          id={''}
          buttonName={effectiveFromDate >= formattedCurrentDate ? "Unlink" : props.user.effective_to_dt === '-----' ? 'Unlink' :
            effectiveToDate > formattedCurrentDate ? "UnLink" : "Link"}
          colorType={'primary'}
          disabled={ userDetails?.user_status === 'Inactive' ||
            currentDate === props.user.effective_from_dt
            || effectiveFromDate > formattedCurrentDate
            || props.user?.is_parent || (props.user?.district_name !== userDetails?.district_name)
          } />
        )}
      </div>}
        {canHistoryUser && (
          <LinkUnlinkHistoryButton
            id={''}
            buttonName={"Detail"}
            colorType={'primary'}
            disabled={false}
            onClick={handleClickHistory}
          />
        )}
        {showFacHistory && <UserFacilityModal
          contents={contents} title={'Facility Detail'} closeModal={closeUserFacilityModal} showModal={show} />
        }
      </div>
      <div>
        <Modal
          show={showModal}
          onHide={handleClose}
          dialogClassName={'verify-card-modal'}
          backdrop = "static"
        >
          <Modal.Body  >
            {<div>
              {(!isDeleteButtonClicked && showModal) && <div className="verification_card_component">
                <div className="verification-page-one">
                  <CommonCardComponent
                    cardHeader={((props.user.effective_to_dt === '-----' || effectiveToDate > formattedCurrentDate) &&
                      effectiveFromDate <= formattedCurrentDate)
                      ? 'Add Details to Unlink' : 'Add Details to Link'}
                    cardBodyContent={
                      <>
                        <form className="container_health_block">
                          <CommonFormFields
                            formData={modalData}
                            formState={modalForm}
                            handleFormChange={handleFormChange}
                          />
                        </form>
                      </>
                    }
                  />
                </div>
              </div>}
              {isDeleteButtonClicked && <>
                <div className="verification_card_component">
                  <div className="verification-page-one">
                    <CommonCardComponent
                      cardHeader={`Delete the linked facility ${props.user.hfr_id}`}
                      cardBodyContent={
                        <>
                          <form className="container_health_block">
                            <CommonFormFields
                              formData={deleteData}
                              formState={deleteForm}
                              handleFormChange={(value, key, option, id, code) => {
                                if (key === "remarks" && value.length > 30) {
                                  return;
                                }
                                setDeleteForm((prevState) => ({
                                  ...prevState,
                                  [key]: {
                                    ...prevState[key],
                                    value: value,
                                    isError: false,
                                    message: '',
                                    id: id,
                                    code: code
                                  },
                                }));
                              }} />
                          </form></>}
                    />
                  </div>
                </div>
              </>
              }
              <div className='button_wrapper_bottom'>
                <Button
                  onClick={() => {
                    if (isDeleteButtonClicked) {
                      setIsDeleteButtonCLicked(false)
                      handleClose()
                    }
                    window.scrollTo({
                      top: 0,
                      behavior: 'smooth'
                    });
                    handleClose()
                  }}

                  disabled={false}
                  id={''}
                  buttonName={isDeleteButtonClicked ? "No" : 'Cancel'}
                  colorType={'save'} />
                <Button
                  onClick={() => {
                    if (isDeleteButtonClicked) {
                      //if (deleteForm.remarks.value !== '') {
                      handleDelete();

                      //}
                    }
                    else {
                      if (((props.user.effective_to_dt === '-----' || effectiveToDate > formattedCurrentDate) &&
                        effectiveFromDate <= formattedCurrentDate)) {
                        handleUnlink();
                      }
                      else {
                        handleLink();
                      }
                    }

                  }}
                  disabled={false}
                  id={''}
                  buttonName={isDeleteButtonClicked ? 'Yes' : linkedFacilitiesCount === 1 && modalForm.reasonForUnlinking.value !== 'Inactive' ?
                    'Confirm' : ((props.user.effective_to_dt === '-----' || effectiveToDate > formattedCurrentDate) &&
                      effectiveFromDate <= formattedCurrentDate) ? 'Confirm & Unlink' : 'Confirm & Link'}
                  colorType={'primary'} />
              </div>
            </div>}
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};
HealthProviderAction.displayName = 'HealthProviderAction';
export default HealthProviderAction;